import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const RefundBillIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="54" height="40" viewBox="0 0 54 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="mask0_13092_296675"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="13"
      y="2"
      width="41"
      height="36"
    >
      <path
        d="M20.927 3.85227C21.1205 3.36736 21.6539 3.11078 22.1507 3.27214C23.7476 3.79083 27.1611 4.96085 29.3899 6.16481C32.5508 7.87229 33.7547 9.70366 36.8385 11.544C41.545 14.3527 49.2168 16.7551 52.0147 17.5811C52.5842 17.7492 52.8871 18.367 52.6672 18.9182L45.8986 35.8794C45.7088 36.3549 45.1955 36.6136 44.7038 36.4696C42.0932 35.7053 34.1503 33.2527 29.3246 30.3728C26.2408 28.5325 25.0369 26.7012 21.876 24.9937C19.7142 23.8259 16.4379 22.6901 14.7857 22.1495C14.2314 21.9682 13.9406 21.3594 14.1566 20.8179L20.927 3.85227Z"
        fill="#959693"
        stroke="white"
        strokeWidth="1.5"
      />
    </mask>
    <g mask="url(#mask0_13092_296675)">
      <path
        d="M20.927 3.85227C21.1205 3.36736 21.6539 3.11078 22.1507 3.27214C23.7476 3.79083 27.1611 4.96085 29.3899 6.16481C32.5508 7.87229 33.7547 9.70366 36.8385 11.544C41.545 14.3527 49.2168 16.7551 52.0147 17.5811C52.5842 17.7492 52.8871 18.367 52.6672 18.9182L45.8986 35.8794C45.7088 36.3549 45.1955 36.6136 44.7038 36.4696C42.0932 35.7053 34.1503 33.2527 29.3246 30.3728C26.2408 28.5325 25.0369 26.7012 21.876 24.9937C19.7142 23.8259 16.4379 22.6901 14.7857 22.1495C14.2314 21.9682 13.9406 21.3594 14.1566 20.8179L20.927 3.85227Z"
        fill="#959693"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M38.0524 27.4093C38.5476 33.923 45.1209 38.3498 45.1209 38.3498L26.6053 33.923C26.6053 33.923 25.798 26.0388 28.2404 21.3203C29.8021 18.3033 38.5437 8.52734 38.5437 8.52734C38.5437 8.52734 42.7497 7.57575 42.2778 11.0586C41.8557 14.174 37.6344 21.9113 38.0524 27.4093Z"
        fill="#6D6E6B"
      />
      <path
        d="M21.985 19.1231C22.4803 25.6369 29.0536 30.0636 29.0536 30.0636L10.538 25.6369C10.538 25.6369 10.4632 19.8403 12.9057 15.1219C14.4674 12.1049 23.3882 0.749966 23.3882 0.749966C23.3882 0.749966 21.0998 7.47886 21.985 19.1231Z"
        fill="#6D6E6B"
      />
      <path
        d="M20.927 3.85227C21.1205 3.36736 21.6539 3.11078 22.1507 3.27214C23.7476 3.79083 27.1611 4.96085 29.3899 6.16481C32.5508 7.87229 33.7547 9.70366 36.8385 11.544C41.545 14.3527 49.2168 16.7551 52.0147 17.5811C52.5842 17.7492 52.8871 18.367 52.6672 18.9182L45.8986 35.8794C45.7088 36.3549 45.1955 36.6136 44.7038 36.4696C42.0932 35.7053 34.1503 33.2527 29.3246 30.3728C26.2408 28.5325 25.0369 26.7012 21.876 24.9937C19.7142 23.8259 16.4379 22.6901 14.7857 22.1495C14.2314 21.9682 13.9406 21.3594 14.1566 20.8179L20.927 3.85227Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M23.8371 10.6601C24.6002 10.9581 25.4649 10.5829 25.7685 9.82212L26.6101 7.71306C26.6101 7.71306 28.7644 8.19762 29.879 8.98985C31.3577 10.0409 33.2071 12.4898 35.8474 14.0274C38.0365 15.3022 41.7728 16.4043 42.318 16.5617C42.3645 16.5751 42.4077 16.5897 42.4527 16.6073L46.0373 18.0074L45.1957 20.1165C44.892 20.8773 45.2645 21.7356 46.0275 22.0337L47.5315 22.6211L46.1402 26.1078L44.7488 29.5944L42.8615 28.8573C42.0985 28.5592 41.2338 28.9344 40.9302 29.6952L40.0885 31.8043L36.8872 30.5539C36.8422 30.5363 36.7989 30.5217 36.7525 30.5083C36.2072 30.3509 32.471 29.2487 30.2819 27.9739C27.6416 26.4363 27.0343 24.33 24.3134 22.9364C23.0946 22.3122 21.0446 21.6596 21.0446 21.6596L21.8862 19.5506C22.1898 18.7898 21.8174 17.9314 21.0544 17.6334L19.1671 16.8962L20.5585 13.4096L21.9499 9.92292L23.8371 10.6601Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M36.4238 22.2637C35.4731 24.6462 33.2695 25.7105 31.6669 25.0845C30.0643 24.4586 29.1899 22.192 30.1407 19.8095C31.0915 17.427 33.295 16.3627 34.8976 16.9887C36.5003 17.6146 37.3746 19.8812 36.4238 22.2637Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
    <path
      d="M13.507 11.1713L-6.31505e-07 22.7318L13.507 34.2923L13.507 27.6995C13.507 27.6995 20.9574 27.5287 24.7825 29.8595C32.4027 34.5028 23.8985 37.1554 23.8985 37.1554C23.8985 37.1554 30.094 37.7259 31.1234 33.2432C32.2132 28.4972 29.791 26.4781 28.2849 24.6076C23.8572 19.1085 13.507 17.7635 13.507 17.7635L13.507 11.1713Z"
      fill="url(#paint0_radial_13092_296675)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_13092_296675"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.99001 15.5207) rotate(48.7005) scale(35.581 29.4239)"
      >
        <stop offset="0.413589" stopColor="#6450F7" />
        <stop offset="0.420362" stopColor="#4B3DB2" />
      </radialGradient>
    </defs>
  </svg>
)
